import { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import CandidateLogin from "./CandidateLogin";
import { Button, Dropdown, Modal, Space } from "antd";
import { FaCaretDown } from "react-icons/fa6";
import { PiWarningCircleLight } from "react-icons/pi";
import useLayoutStore from "../store/LayoutStore";

const HireHubHeader = () => {
  const urlParams = new URLSearchParams(window.location.search);
  const location = useLocation();
  const navigate = useNavigate();
  const currentUser = JSON.parse(localStorage.getItem("candidate"));
  const [openCandidateLogin, setOpenCandidateLogin] = useState(false);
  const [isLogout, setIsLogout] = useState(false);
  let isLogin = urlParams.get("isLogin");
  const isLoginPage = location.pathname === "/login";
  const isSignupPage = location.pathname === "/signup";
  const isJobsPage = location.pathname === "/jobs";
  const { activeNav, setActiveNav } = useLayoutStore();

  useEffect(() => {
    if (isLogin == "true") {
      setOpenCandidateLogin(true);
    }
  }, [isLogin]);
  const candidateOnClose = () => {
    setOpenCandidateLogin(false);
  };

  const handleClick = ({ key }) => {
    setIsLogout(true);
  };

  const profileDetails = ({ key }) => {
    setActiveNav("1");
    navigate("/profile");
  };

  const myjobs = ({ key }) => {
    setActiveNav("2");
    navigate("/myJobs");
  };
  const viewassessment = ({ key }) => {
    setActiveNav("3");
    navigate("/viewAssessment");
  };

  const items = [
    {
      label: (
        <span
          className={`${activeNav === "0" ? "font-semibold" : "font-normal"}`}
        >
          Home
        </span>
      ),
      key: "0",
      onClick: () => {
        setActiveNav("0");
        navigate("/");
      },
    },
    {
      label: (
        <span
          className={`${activeNav === "1" ? "font-semibold" : "font-normal"}`}
        >
          My Profile
        </span>
      ),
      key: "1",
      onClick: profileDetails,
    },
    {
      label: (
        <span
          className={`${activeNav === "2" ? "font-semibold" : "font-normal"}`}
        >
          My Jobs
        </span>
      ),
      key: "2",
      onClick: myjobs,
    },
    {
      label: (
        <span
          className={`${activeNav === "3" ? "font-semibold" : "font-normal"}`}
        >
          Assessments
        </span>
      ),
      key: "3",
      onClick: viewassessment,
    },
    {
      label: "Logout",
      key: "4",
      onClick: handleClick,
    },
  ];

  const LogoutItems = [
    {
      label: <span>Home</span>,
      key: "0",
      onClick: () => {
        setActiveNav("0");
        navigate("/");
      },
    },
    {
      label: "Login",
      key: "4",
      onClick: () => navigate("/login"),
    },
  ];

  const handleLogout = () => {
    localStorage.removeItem("candidate");
    localStorage.removeItem("user_id");
    navigate("/");
    window.location.reload();
  };

  const modalContent = (
    <div>
      <p className="text-[#000] text-xl font-bold  mt-4 flex item-center justify-center">
        <PiWarningCircleLight
          className="w-20 h-20"
          style={{
            display: "flex",
            fontSize: "48px",
            color: "#52c41a",
            paddingBottom: "25px",
            alignItems: "center",
            justifyContent: "center",
            flexDirection: "column",
          }}
        />
      </p>
      <p className="flex justify-center mb-4 text-lg font-bold item-center">
        Logout
      </p>
      <p className="text-[#000] flex item-center justify-center">
        Are you sure want to logout?{" "}
      </p>
      <div className="flex justify-end">
        <Button
          className="bg-[#1C4980] text-white text-base"
          onClick={handleLogout}
        >
          Logout
        </Button>
      </div>
    </div>
  );

  return (
    <div className="flex items-center justify-center dark:bg-[#1A1D21]  ">
      <div className="w-full md:w-3/4">
        <div className="flex flex-row justify-between ">
          {currentUser === null ? (
            <>
              <div className="flex flex-wrap mt-8 space-x-6">
                <div className="flex items-center justify-end w-full">
                  {isLoginPage ? (
                    <div className="flex items-center justify-center gap-2 ml-4 md:gap-4">
                      <p className="text-sm text-center text-gray-600 md:text-base sm:text-left">
                        Don't have an account?
                      </p>
                      <Link
                        to="/signup"
                        className="border border-blue-500 text-sm md:text-base px-3 md:px-5 py-1.5 md:py-2 rounded-md hover:text-white hover:bg-[#0071DC] transition duration-300 text-center mr-5 md:mr-0 "
                      >
                        Sign Up Now
                      </Link>
                    </div>
                  ) : isJobsPage ? (
                    <>
                    <div className="px-2">Jobs</div>
                    <div className="pl-2">
                    <Dropdown
                      menu={{
                        items: LogoutItems,
                      }}
                      placement="bottomRight"
                    >
                      <a
                        onClick={(e) => e.preventDefault()}
                        className="cursor-pointer"
                      >
                        <Space>
                          <FaCaretDown />
                        </Space>
                      </a>
                    </Dropdown>
                    </div>
                    
                    </>
                  ) : (
                    <div className="flex items-center justify-center gap-2 ml-4 md:gap-4">
                      {isSignupPage && (
                        <p className="text-sm text-gray-600 md:text-base">
                          Do you have an account?
                        </p>
                      )}
                      <Link
                        to="/login"
                        className="border border-blue-500 text-sm md:text-base px-3 md:px-5 py-1.5 md:py-2 rounded-md hover:text-white hover:bg-[#0071DC] transition duration-300 text-center mr-5 md:mr-0"
                      >
                        Sign In
                      </Link>
                    </div>
                  )}
                </div>
              </div>

              {openCandidateLogin && (
                <CandidateLogin
                  open={openCandidateLogin}
                  onClose={candidateOnClose}
                />
              )}
            </>
          ) : (
            <div className="flex mt-8">
              <div className="px-2">{currentUser.first_name}</div>
              <div className="pl-2">
                <Dropdown
                  menu={{
                    items,
                  }}
                  placement="bottomRight"
                >
                  <a
                    onClick={(e) => e.preventDefault()}
                    className="cursor-pointer"
                  >
                    <Space>
                      <FaCaretDown />
                    </Space>
                  </a>
                </Dropdown>
              </div>
            </div>
          )}
        </div>
        <div className="h-[1px] mt-6"></div>
        {isLogout && (
          <Modal
            className="settingsPage"
            title={""}
            open={isLogout}
            width={500}
            onCancel={() => setIsLogout(false)}
            footer={null}
          >
            {modalContent}
          </Modal>
        )}
      </div>
    </div>
  );
};

export default HireHubHeader;
